import React from 'react';
import Camaras from '../../components/Camaras';
import PrintStyles from '../../components/estilos';
import Footer from '../../../components/Footer/Footer';
import styled from 'styled-components/macro';
import HeaderTitle from '../../../components/Headers/HeaderTitle/index';
import { getNomenclatorColorsByElecCode } from '../../../utils/nomenclatorUtils';
import Logo from '../../../assets/img/COBRANDING_ELECCIONES_2023-08.png';
import { useTranslate } from '../../../contexts/languageContext';
import { parseaFechaHora, getParents } from '../../../utils';
import TablaGenerales from '../../../print/components/TablaGenerales';
import { useMesa, useViewContext } from '../../../contexts/viewContext';

export function HeaderGeneralPrint({ nomenclator, data, breakBefore = true }) {
  const t = useTranslate();
  const { mesa } = useMesa();
  const { scope } = useViewContext();
  const { elec, amb, mdhm, tope } = data;
  const esBoletin = tope === '1';

  const nomenclatorColors = getNomenclatorColorsByElecCode(nomenclator, elec);
  const ambito = mesa
    ? scope
    : nomenclator.ambitos[elec].find(x => x.c === amb);
  const [hora, fecha] = parseaFechaHora(mdhm).split(' - ');

  const genealogy = [
    ambito.i,
    ...getParents(ambito.i, elec, nomenclator, ambito.l),
  ];
  let genealogyNames = genealogy.map(item => {
    return nomenclator.ambitos[elec][item].n.toLowerCase();
  });
  if (mesa) {
    genealogyNames.unshift(`Mesa ${mesa.slice(-6)}`);
  }
  genealogyNames = genealogyNames
    .slice(0, 2)
    .reverse()
    .join(' / ');

  return (
    <div
      style={{
        marginBottom: '2rem',
        breakBefore: breakBefore ? 'page' : 'unset',
      }}
    >
      <HeaderPrint>
        <HeaderTitle
          title={t(nomenclator.nomAmbitos[elec].n)}
          subtitle={genealogyNames}
          color={nomenclatorColors.c}
          marginBottom="unset"
          withDropdown={false}
        />
        <img
          src={Logo}
          alt={'Logos'}
          style={{ padding: '8px', height: '100%', width: '300px' }}
        />
      </HeaderPrint>
      <DateContainer>
        <span>{esBoletin ? t('boletin') : t('avance')}</span>
        <span>{data.numact}</span>
        <span>
          <Hour>{hora}</Hour>
        </span>
        <span>{fecha}</span>
      </DateContainer>
    </div>
  );
}

export default function GeneralPrint(props) {
  function isFirefox() {
    return /Firefox/i.test(navigator.userAgent);
  }

  return (
    <>
      {props?.nomenclator &&
        props?.data?.data &&
        props?.data?.data?.elec &&
        props?.data?.data?.amb && (
          <>
            <PrintStyles />
            <div
              className="pdfPrint"
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              <HeaderGeneralPrint
                nomenclator={props?.nomenclator}
                data={props?.data?.data}
                elec={props?.data?.data?.elec}
                amb={props?.data?.data?.amb}
                breakBefore={false}
              />
              <div className="main">
                <section className="datosGeneralesTotal">
                  <TablaGenerales
                    data={props?.data}
                    nomenclator={props?.nomenclator}
                    ini={props?.ini}
                    className="container content"
                  />
                </section>
              </div>
              <Camaras
                className="camaracircunscripcion"
                header={
                  <HeaderGeneralPrint
                    nomenclator={props?.nomenclator}
                    data={props?.data?.data}
                    elec={props?.data?.data?.elec}
                    amb={props?.data?.data?.amb}
                  />
                }
              />
              <div style={{ breakBefore: 'page' }} />
              {isFirefox() && <div style={{ height: '100vh' }} />}
              <Footer />
            </div>
          </>
        )}
    </>
  );
}

const HeaderPrint = styled.h3`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const DateContainer = styled.div`
  display: flex;
  gap: 0.5rem;
`;

const Hour = styled.span`
  color: #e40424;
`;
